import React, { Component, ErrorInfo } from 'react';
import { Button } from 'antd';

import { IProps, IState } from './error-boundary.type';
import {
  Wrapper,
  Title,
  Message,
  Reason,
  ReasonLabel,
  ReasonBody,
} from './error-boundary.style';

const formatComponentStack = (stack?: string | null) => {
  if (!stack) return 'Localização não disponível.';

  return stack
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .slice(0, 6)
    .join('\n');
};

class ErrorBoundary extends Component<IProps, IState> {
  state: IState = {
    hasError: false,
    errorName: '',
    errorMessage: '',
    componentStack: '',
  };

  static getDerivedStateFromError(error: Error): Partial<IState> {
    return {
      hasError: true,
      errorName: error?.name || 'Error',
      errorMessage: error?.message || 'Erro desconhecido no frontend.',
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Erro capturado pelo ErrorBoundary:', error, errorInfo);

    this.setState({
      componentStack: formatComponentStack(errorInfo.componentStack),
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Wrapper>
          <Title>Ocorreu um erro na interface</Title>
          <Message>
            A página não pôde ser exibida. Veja o tipo do erro, o motivo e onde
            ele ocorreu.
          </Message>
          <Reason>
            <ReasonLabel>Tipo</ReasonLabel>
            <ReasonBody>{this.state.errorName}</ReasonBody>
            <ReasonLabel>Motivo</ReasonLabel>
            <ReasonBody>{this.state.errorMessage}</ReasonBody>
            <ReasonLabel>Onde</ReasonLabel>
            <ReasonBody>{this.state.componentStack || 'Carregando...'}</ReasonBody>
          </Reason>
          <Button type="primary" onClick={this.handleReload}>
            Recarregar página
          </Button>
        </Wrapper>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
